import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    n: "01",
    title: "Connect",
    body: "The Joseph Guild brings together righteous, purpose-driven businesses within the Church — a fellowship of owners who believe that work is worship and commerce can carry conviction.",
  },
  {
    n: "02",
    title: "Support",
    body: "Members lean on one another with counsel, prayer, and practical help. No business in the Guild ever walks alone.",
  },
  {
    n: "03",
    title: "Exchange",
    body: "Opportunities move freely here. Your registration lets us share your products and services with every member of the network, opening doors you could not open yourself.",
  },
  {
    n: "04",
    title: "Grow",
    body: "Referrals, partnerships, and business-to-business collaboration — so that each venture, like Joseph's stewardship in Egypt, multiplies for the good of all.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="relative py-28 lg:py-40" data-testid="manifesto-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gold-dark"
      >
        The Manifesto
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
        className="mb-20 max-w-2xl font-serif text-4xl font-light tracking-tighter text-charcoal sm:text-5xl lg:mb-28"
      >
        Four convictions, <span className="italic text-gold-dark">one guild.</span>
      </motion.h2>

      <div className="flex flex-col gap-20 lg:gap-28">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: EASE, delay: i * 0.06 }}
            className={`grid grid-cols-1 gap-8 border-t border-stone_warm pt-10 md:grid-cols-12 ${i % 2 === 1 ? "md:text-left" : ""}`}
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <div className="md:col-span-3">
              <span className="font-serif text-6xl font-light tracking-tighter text-gold lg:text-7xl">
                {c.n}
              </span>
            </div>
            <div className="md:col-span-3">
              <h3 className="font-serif text-3xl font-medium tracking-tight text-charcoal">{c.title}</h3>
            </div>
            <div className="md:col-span-6">
              <p className="max-w-xl text-base leading-relaxed text-charcoal/70">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: EASE }}
        className="mt-28 grid grid-cols-1 items-center gap-10 lg:grid-cols-12"
      >
        <figure className="overflow-hidden lg:col-span-5" data-testid="manifesto-image-frame">
          <motion.img
            initial={{ scale: 1.12 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.6, ease: EASE }}
            src="https://images.pexels.com/photos/8554435/pexels-photo-8554435.jpeg"
            alt="Business owners in warm conversation"
            className="aspect-[4/3] w-full object-cover"
          />
        </figure>
        <blockquote className="lg:col-span-6 lg:col-start-7">
          <p className="font-serif text-2xl font-light italic leading-snug tracking-tight text-charcoal sm:text-3xl">
            “Your registration builds the network — and the network builds your business.”
          </p>
          <figcaption className="mt-6 font-mono text-[10px] uppercase tracking-[0.28em] text-charcoal/45">
            The Joseph Guild — founding charter
          </figcaption>
        </blockquote>
      </motion.div>
    </div>
  </section>
);
